var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-intro"},[_c('b-pagination-nav',{attrs:{"value":_vm.currentPage,"number-of-pages":3,"pills":"","align":"center","use-router":"","hide-goto-end-buttons":true,"disabled":true},scopedSlots:_vm._u([{key:"page",fn:function({ page }){return [_c('span',[_vm._v(_vm._s(page))])]}}])}),_c('register-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }